document.addEventListener('DOMContentLoaded', () => {

    const blocks = document.querySelectorAll('.block--location-slider');

    function create_location_slider() {

        return {
            block: null,

            init: function (block) {
                this.block = block;
                this.swiper();
            },

            swiper: function () {
                const swiperEl = this.block.querySelector('.swiper');

                if (!swiperEl) {
                    return;
                }

                const wrapper      = this.block.querySelector('.swiper-wrapper');
                const slidesPerView = wrapper ? parseInt(wrapper.dataset.slidesPerView, 10) || 4 : 4;

                new Swiper(swiperEl, {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    speed: 500,
                    pagination: {
                        el: this.block.querySelector('.location-slider__pagination'),
                        clickable: true,
                    },
                    navigation: {
                        prevEl: this.block.querySelector('.location-slider__btn--prev'),
                        nextEl: this.block.querySelector('.location-slider__btn--next'),
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: slidesPerView,
                            spaceBetween: 24,
                        },
                    },
                    modules: [Navigation, Pagination],
                });
            },
        };
    }

    blocks.forEach(block => {
        const location_slider = create_location_slider();
        location_slider.init(block);
    });

});
